import styled, { keyframes } from 'styled-components';

import CheckMark from 'Assets/mtm/check.png';

export const SidebarWrapper = styled.div`
  padding-right: 6px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  max-width: none;
  > *:last-child {
    margin-bottom: 0;
  }
`;

export const Title = styled.h2`
  color: var(--colors-gray-black);
  font-family:
    Gelica,
    Museo Sans,
    sans-serif;
  font-weight: 500;
  font-size: 1.8rem;
  line-height: 1.35;
  letter-spacing: -0.005em;
  margin-bottom: 1rem;
  @media (min-width: 1301px) {
    font-size: 1.95rem;
    line-height: 1.3;
  }
`;

export const Body = styled.p`
  font-size: 14px;
  color: var(--colors-gray-black);
  margin-bottom: 20px;
`;

export const Subheader = styled.h3`
  font-size: 1rem;
  font-weight: 300;
  margin-bottom: 1.5rem;
  color: var(--colors-gray-black);
`;

export const CTAButton = styled.a`
  background: #ffe25f;
  border-radius: 8px;
  padding: 10px 16px;
  color: #2b2d42;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin-bottom: 24px;
  font-weight: 500;
  font-size: 1.1rem;
  &:hover {
    background: #ffdb3a;
  }
`;

export const CodeContainer = styled.div`
  p {
    margin: 0 0 8px;
    font-size: 14px;
    color: #444;
  }
`;

export const CodeBox = styled.div`
  border: 1px solid #ccc;
  padding: 8px 12px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
`;

export const CopyIconWrapper = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
`;
export const CopiedIcon = styled.div`
  width: 18px;
  height: 18px;
  background: url(${CheckMark}) no-repeat center center;
  background-size: contain;
  margin-right: 0.5rem;
  color: #ffffff;
`;

const copiedComponentAnimationFadeInOut = keyframes`
  0% { opacity: 0; transform: translateY(10px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-10px); }
`;

export const CopiedWrapper = styled.div`
  height: 45px;
  margin-top: 9px;
`;

export const CopiedComponent = styled.div`
  background: #2f2f52b2;
  color: #ffffff;
  animation: ${copiedComponentAnimationFadeInOut} 4s ease-in-out forwards;
  display: flex;
  align-items: center;
  font-size: 16px;
  width: 117px;
  border-radius: 8px;
  padding: 6px 12px;
`;
